import React, { useState, useEffect, useContext } from "react";
import "./Navbar.css";
import { useNavigate, useLocation } from "react-router-dom";
import { CartContext } from "../../contexts/CartContext";
import FestivalSpecial from "../FestivalSpecial/FestivalSpecial";
import { useIndependenceDayTheme } from "../../lib/useIndependenceDayTheme";
import HeaderConvoy from "../independence-day/HeaderConvoy";
import IndependenceFlag from "../independence-day/IndependenceFlag";
// import MobileConvoyBar from "../independence-day/MobileConvoyBar";
import DemoForm from "./DemoForm";
import { useWebsiteData } from "../../contexts/WebsiteDataContext";
import axios from "axios";
import { RiCustomerService2Line } from "react-icons/ri";
import ApiService from "../Services/ApiServices";
import { useAuth } from "../../contexts/AuthContext";

const Navbar = () => {
  // const websiteData = useWebsiteData();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [cartQuantity, setQuantity] = useState(0);
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLoginDropdown, setShowLoginDropdown] = useState(false);
  const { cartItems, setCartItems } = useContext(CartContext || { cartItems: [] });
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [websiteData, setWebsiteData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { isAuthenticated, logout } = useAuth();


  const [festival, setFestival] = useState(null);
  /* Same gate the hero, popup and ambience use, so the whole theme switches
   * on and off together rather than the header running its own schedule. */
  const idDay = useIndependenceDayTheme();

  useEffect(() => {
    const fetchWebsiteData = async () => {
      try {
        const payload = {
          companyCode: "WAY4TRACK",
          unitCode: "WAY4",
        };

        const response = await ApiService.post(
          "/website-product/getWebsiteProductDetails",
          payload
        );

        if (response.status) {
          setWebsiteData(response.data);
        } else {
          setError("Failed to fetch data");
        }
      } catch (err) {
        setError("Error fetching website data: " + err.message);
        console.error("Error fetching website data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWebsiteData();
  }, []);

  useEffect(() => {
    const festivals = [
      { name: "IndependenceDay", start: "2026-08-13", end: "2026-08-13" },
      { name: "Diwali", start: "2026-11-10", end: "2026-11-15" },
      { name: "Christmas", start: "2026-12-23", end: "2026-12-26" },
      { name: "NewYear", start: "2027-01-01", end: "2027-01-02" },
      { name: "Sankranti", start: "2027-01-13", end: "2027-01-16" },
      { name: "Ramzan", start: "2027-03-10", end: "2027-03-10" },
      { name: "Holi", start: "2027-03-22", end: "2027-03-22" },
      { name: "Ugadi", start: "2027-04-07", end: "2027-04-07" },
      // add other festivals if needed
    ];

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const active = festivals.find((f) => {
      const start = new Date(f.start);
      start.setHours(0, 0, 0, 0);
      const end = new Date(f.end);
      end.setHours(0, 0, 0, 0);
      return today >= start && today <= end;
    });

    if (active) setFestival(active);
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   checkLogin();
  // }, []);

  // useEffect(() => {
  //   const handleAuthChange = () => {
  //     checkLogin();
  //   };

  //   window.addEventListener("auth-change", handleAuthChange);

  //   return () => {
  //     window.removeEventListener("auth-change", handleAuthChange);
  //   };
  // }, []);

  // const checkLogin = async () => {
  //   try {
  //     const res = await ApiService.get("/auth/me");
  //     if (res?.status) {
  //       setIsLoggedIn(true);
  //     } else {
  //       setIsLoggedIn(false);
  //     }
  //   } catch (error) {
  //     setIsLoggedIn(false);
  //   }
  // };

  // const checkLogin = async () => {
  //   const cached = localStorage.getItem("auth_status");

  //   if (cached === "true") {
  //     setIsLoggedIn(true);
  //     return;
  //   }

  //   try {
  //     const res = await ApiService.get("/auth/me");
  //     const status = !!res?.status;

  //     setIsLoggedIn(status);
  //     localStorage.setItem("auth_status", status);
  //   } catch (error) {
  //     setIsLoggedIn(false);
  //     localStorage.setItem("auth_status", "false");
  //   }
  // };

  // const checkLogin = async () => {
  //   try {
  //     const res = await ApiService.get("/auth/me");

  //     setIsLoggedIn(!!res?.status);
  //   } catch (error) {
  //     setIsLoggedIn(false);
  //   }
  // };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    setQuantity(cartItems.length);
  }, [cartItems]);

  const isActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      localStorage.removeItem("auth_status");
      localStorage.removeItem("client_id");
      localStorage.removeItem("client_db_id");
      localStorage.removeItem("token");
    }
  };

  // Function to handle external login redirects
  const handleExternalLogin = (url) => {
    window.open(url, '_blank');
    setShowLoginDropdown(false);
    setIsMenuOpen(false);
  };

  const validProducts = websiteData?.filter(
    (product) =>
      product.name !== "Dummy Product" &&
      product.device?.length > 0
  ) || [];


  return (
    <div className="navbar-main-container">
      <FestivalSpecial />

      {/* (1) tricolour strip above the header */}
      {idDay && (
        <div className="w4t-id-strip" aria-hidden="true">
          <span /><span /><span />
        </div>
      )}

      <nav className={`navbar ${festival ? "with-festival" : ""}`}>
        {/* <FestivalSpecial /> */}
        <div className="nav-container">
          {/* Logo */}
          <div className="nav-logo-container">
            <img className="nav-logo-img" src="/images/way4track_main_logo.png" alt="way4track_logo" />
            <div className="nav-logo" onClick={() => window.location.href = "/"}>
              {/* (2) flag right after the wordmark. The wordmark and tagline
                  are stacked in a column, so on the festival date the wordmark
                  is wrapped in a row with the flag. Off-festival the markup is
                  byte-identical to before. */}
              {idDay ? (
                <span className="w4t-id-markrow">
                  <span className="logo nav-logo-heading">WAY4TRACK</span>
                  <IndependenceFlag width={17} />
                </span>
              ) : (
                <span className="logo nav-logo-heading">WAY4TRACK</span>
              )}
              <span className="logo nav-logo-para">Track anything, anytime, anywhere</span>
            </div>
          </div>

          {/* (3) convoy between the logo block and the right-hand cluster —
              the diorama version: road, scenery, GPS pings, breadcrumbs */}
          {idDay && <HeaderConvoy seconds={26} />}

          <div className="mobile-nav-right">
            {/* CART */}
            <div
              className="mobile-icon"
              onClick={() => {
                navigate("/cart");
                window.scrollTo(0, 0);
              }}
            >
              🛒
              {cartQuantity > 0 && <span className="cart-badge">{cartQuantity}</span>}
            </div>

            {/* USER */}
            <div
              className="mobile-icon"
              onClick={() => {
                if (isAuthenticated) {
                  navigate("/my-profile");
                } else {
                  navigate("/login");
                }
                window.scrollTo(0, 0);
              }}
            >
              <img
                src="/images/profile-logo.png"
                alt="Profile"
                className="profile-icon"
              />
            </div>

            {/* HAMBURGER — (5) on the festival date the three bars take the
                tricolour; off the date the class is absent and the markup is
                byte-identical to before */}
            <div
              className={`hamburger ${isMenuOpen ? "active" : ""}${idDay ? " w4t-id-burger" : ""}`}
              onClick={toggleMenu}
            >
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </div>
          </div>

          {/* Navigation */}
          <div className={`nav-content ${isMenuOpen ? "active" : ""}`}>
            <a
              className="customer-support-container"
              href="tel:7416867575"
            // onClick={() => { navigate("/"); window.scrollTo(0, 0) }}
            >
              <RiCustomerService2Line className="customer-support-icon" />
              <div className="customer-support-sub-container">
                <span className="customer-support-name">Customer Support </span>
                <span className="customer-support-number">+91 74168 67575</span>
              </div>
            </a>
            <ul className="menu-list">

              <li
                className={`menu-item ${isActive("/") ? "active" : ""}`}
                onClick={() => { navigate("/"); window.scrollTo(0, 0) }}
              >
                Home
              </li>
              <li
                className={`menu-item ${isActive("/products") ? "active" : ""}`}
                onClick={() => { navigate("/products"); window.scrollTo(0, 0); }}
              >
                Products

              </li>

              {/* <li
                className={`menu-item product-menu ${isActive("/products") ? "active" : ""}`}
              >
                <span
                  onClick={() => {
                    navigate("/products");
                    window.scrollTo(0, 0);
                  }}
                >
                  Products
                </span>

                <div className="products-dropdown">
                  <div className="dropdown-content">
                    {websiteData?.map((item, index) => (
                      <div
                        key={index}
                        className="dropdown-item"
                        onClick={() => {
                          navigate(`/${item.layoutType}/${item.id}`);
                          window.scrollTo(0, 0);
                        }}
                      >
                        {item.name}
                      </div>
                    ))}
                  </div>
                </div>
              </li> */}

              <li
                className={`menu-item ${isActive("/blogs") ? "active" : ""}`}
                onClick={() => { navigate("/blogs"); window.scrollTo(0, 0); }}
              >
                Blogs
              </li>
              <li
                className={`menu-item ${isActive("/contact") ? "active" : ""}`}
                onClick={() => { navigate("/contact"); window.scrollTo(0, 0) }}
              >
                Contact Us
              </li>
              <li
                className={`menu-item ${isActive("/Careers") ? "active" : ""}`}
                onClick={() => { navigate("/Careers"); window.scrollTo(0, 0) }}
              >
                Career
              </li>
              <li
                className={`menu-item ${isActive("/about") ? "active" : ""}`}
                onClick={() => setShowDemoModal(true)}
              >
                For Enquiry
              </li>
              {/* <li
                className={`menu-item ${isActive("/about") ? "active" : ""}`}
                onClick={() => { navigate("/about"); window.scrollTo(0, 0) }}
              >
                About Us
              </li> */}





              {/* In mobile view, show profile & logout as simple list items */}
              {isAuthenticated && (
                <div className="mobile-profile-actions">
                  <li
                    className="menu-item"
                    onClick={() => {
                      navigate("/my-profile");
                      window.scrollTo(0, 0);
                      setIsMenuOpen(false);
                    }}
                  >
                    Profile
                  </li>
                  <li
                    className="menu-item"
                    onClick={() => {
                      handleLogout();
                      setIsMenuOpen(false);
                    }}
                  >
                    Logout
                  </li>


                </div>
              )}
            </ul>



            <div className="actions">
              <div className="cart" onClick={() => { navigate("/cart"); window.scrollTo(0, 0) }}>
                🛒 <p className="cart-quantity">{cartQuantity}</p>
              </div>

              {/* Desktop-only profile icon */}
              {isAuthenticated ? (
                <div className="profile-container desktop-only">
                  <img
                    src="/images/profile-logo.png"
                    alt="Profile"
                    className="profile-icon"
                  />
                  <div className="profile-dropdown">
                    <p onClick={() => { navigate("/my-profile"); window.scrollTo(0, 0) }}>Profile</p>
                    <p onClick={handleLogout}>Logout</p>

                  </div>
                </div>
              ) : (
                <div className="login-options">
                  <button
                    className="login-btn main-login"
                    onClick={() => {
                      navigate("/login");
                      window.scrollTo(0, 0);
                    }}
                  >
                    Login
                  </button>

                </div>
              )}
            </div>

            <div className="external-logins-container">
              <button
                className="external-login-toggle"
                onClick={() => setShowLoginDropdown(!showLoginDropdown)}
              >
                ⋮
              </button>
              <div className={`external-logins-dropdown ${showLoginDropdown ? 'active' : ''}`}>
                <button
                  className="external-login-btn online-login"
                  onClick={() => handleExternalLogin("https://way4trackonline.com/jsp/sharon_login.jsp")}
                >
                  WAY4TRACK Online
                </button>
                <button
                  className="external-login-btn pro-login"
                  onClick={() => handleExternalLogin("https://way4trackpro.com/jsp/way4trackPro_login.jsp")}
                >
                  WAY4TRACK Pro
                </button>
                <button
                  className="external-login-btn pro-login"
                  onClick={() => handleExternalLogin("https://way4tracksmartbus.com/jsp/sharontelematics_login.jsp")}
                >
                  WAY4TRACK Smartbus
                </button>
                <button
                  className="external-login-btn pro-login"
                  onClick={() => handleExternalLogin("http://35.154.134.64/jsp/login.jsp")}
                >
                  WAY4TRACK Prime
                </button>
              </div>
            </div>

            {/* <div className="mobile-drawer-bottom">
              <div
                className="drawer-item"
                onClick={() => {
                  navigate("/cart");
                  setIsMenuOpen(false);
                }}
              >
                🛒 Cart ({cartQuantity})
              </div>

              {isLoggedIn ? (
                <>
                  <div
                    className="drawer-item"
                    onClick={() => {
                      navigate("/my-profile");
                      setIsMenuOpen(false);
                    }}
                  >
                    👤 Profile
                  </div>
                  <div
                    className="drawer-item"
                    onClick={() => {
                      handleLogout();
                      setIsMenuOpen(false);
                    }}
                  >
                    🚪 Logout
                  </div>
                </>
              ) : (
                <div
                  className="drawer-item login"
                  onClick={() => {
                    navigate("/login");
                    setIsMenuOpen(false);
                  }}
                >
                  🔐 Login
                </div>
              )}
            </div> */}


          </div>
        </div>
      </nav>
      {showDemoModal && (
        <DemoForm onClose={() => setShowDemoModal(false)} />
      )}

      <div className={`navbar-spacer ${festival ? "navbar-spacer-with-festival" : ""}`}></div>

      {/* (4) the mobile vehicle bar, between the nav and the hero. Commented
          out for now so the screen can be reviewed without it.

          To switch it back on, uncomment the line below AND the
          MobileConvoyBar import at the top of this file. The component and
          mobile-convoy-bar.css are untouched and still in the repo.

          It goes after the spacer rather than inside the nav because .navbar
          is fixed at 60px, so a child would overflow it. The spacer already
          reserves the nav's height, so nothing below shifts when it mounts. */}
      {/* {idDay && <MobileConvoyBar />} */}
    </div>
  );
};

export default Navbar;